<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 165, 0, 0.15), rgba(255, 165, 0, 0.25)); border-color: rgba(255, 165, 0, 0.4); color: #FFA500;">
          <i class="icon triangle up"></i>
          {{nokta ? 'Nokta Seçildi ✓' : 'Nokta Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Kalite Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="kaliteAyarlariAcik = !kaliteAyarlariAcik">
        <i class="icon triangle up"></i>
        <span>Yüzey Kalitesi</span>
        <div class="chevron" [class.right]="!kaliteAyarlariAcik" [class.down]="kaliteAyarlariAcik"></div>
      </div>

      @if (kaliteAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Ra Value -->
        <div class="ayar-satir">
          <label>Ra (μm):</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="raValue" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="0.1" min="0.05" max="50" />
          </div>
        </div>

        <!-- Standart Ra Değerleri -->
        <div class="ayar-satir" style="flex-wrap: wrap;">
          <label style="width: 100%; margin-bottom: 0.2rem;">Standart Değerler:</label>
          <div class="button-grup" style="flex-wrap: wrap; gap: 0.15rem;">
            @for (ra of standartRaDegerleri; track ra) {
            <button class="mini-btn" [class.active]="raValue === ra"
                    (click)="setRaValue(ra)"
                    style="min-width: 35px; font-size: 9px;">
              {{ra}}
            </button>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <!-- İşlem Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="islemAyarlariAcik = !islemAyarlariAcik">
        <i class="icon cog"></i>
        <span>İşlem Ayarları</span>
        <div class="chevron" [class.right]="!islemAyarlariAcik" [class.down]="islemAyarlariAcik"></div>
      </div>

      @if (islemAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- İşlem Tipi -->
        <div class="ayar-satir">
          <label>İşlem Tipi:</label>
          <select [(ngModel)]="islemTipi" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (tip of islemTipleri; track tip.value) {
            <option [value]="tip.value">{{tip.label}}</option>
            }
          </select>
        </div>

        <!-- İşlem Yönü -->
        <div class="ayar-satir">
          <label>İşlem Yönü:</label>
          <select [(ngModel)]="islemYonu" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (yon of islemYonleri; track yon.value) {
            <option [value]="yon.value">{{yon.label}}</option>
            }
          </select>
        </div>

        <!-- Ek İşlem -->
        <div class="ayar-satir">
          <label>Ek İşlem:</label>
          <input type="text" [(ngModel)]="ekIslem" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="Opsiyonel..."
                 style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;" />
        </div>
      </div>
      }
    </div>

    <!-- Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm Ayarları</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazı Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutYuzey" class="catia-checkbox">
            <label for="sabitBoyutYuzey" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!nokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
